// extracted by mini-css-extract-plugin
export default {"button":"_l-z","reviewSort":"am-z"};